import { Badge } from "@/components/ui";
import { type ColumnDef } from "@tanstack/react-table";
import { startCase } from "lodash";
import { DataTableColumnHeader } from "@/components/ui";
import { TooltipWrapper } from "@/components/ui/shadcn/Tooltip/TooltipWrapper";

export type ContactMatterConnectionRow = {
  matterId: string;
  title: string;
  roles: string[];
};

export const contactMatterConnectionTableColumns: ColumnDef<ContactMatterConnectionRow>[] =
  [
    {
      id: "Matter Title",
      accessorKey: "title",
      header: ({ column }) => <DataTableColumnHeader column={column} />,
      cell: ({ row }) => {
        return (
          <div className="flex items-center">
            <span className="truncate">{row.original.title}</span>
          </div>
        );
      },
    },
    {
      id: "Roles",
      accessorKey: "roles",
      header: ({ column }) => <DataTableColumnHeader column={column} />,
      cell: ({ row }) => {
        const formattedRoles = row.original.roles.map(startCase);
        const visibleRoles = formattedRoles.slice(0, 3);
        const hiddenRoles = formattedRoles.slice(3);

        return (
          <div className="flex flex-wrap items-center gap-2">
            {visibleRoles.map((role, index) => (
              <Badge
                key={`${role}-${index}`}
                variant="secondary"
                className="px-2 text-xs whitespace-nowrap"
              >
                {role}
              </Badge>
            ))}
            {hiddenRoles.length > 0 && (
              <TooltipWrapper message={hiddenRoles.join(", ")}>
                <div>
                  <Badge
                    variant="secondary"
                    className="cursor-default px-2 text-xs whitespace-nowrap"
                  >
                    +{hiddenRoles.length}
                  </Badge>
                </div>
              </TooltipWrapper>
            )}
          </div>
        );
      },
    },
  ];
